import es from './es.json';
import en from './en.json';

export const translations = { es, en };
